import { Component, Input } from '@angular/core';

/**
 * One memory, rendered exactly as the Memories screen renders it.
 *
 * The markup and the stylesheet are the same ones that screen uses, so a
 * memory looks like a memory wherever it appears. Actions are opt-in: in a
 * shared workspace a reader cannot forget somebody else's memory, and a
 * keyword there filters nothing, so both are off unless a host asks for them.
 */
@Component({
  selector: 'app-memory-card',
  standalone: false,
  templateUrl: './memory-card.component.html',
  styleUrls: ['./memory-card.component.css'],
})
export class MemoryCardComponent {

  @Input() memory: any;

  /** 1-based position, shown as #n in the card header. */
  @Input() index = 0;

  /** Read-only hosts leave this false and get no delete control. */
  @Input() showActions = false;
}
